import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import EPrescription from './EPrescription';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';

import './index.css';

export default (element, store) => {
  const root = createRoot(element);
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <EPrescription
          examName={element.dataset.examName}
          labelLtc={element.dataset.labelLtc}
          labelNoLtc={element.dataset.labelNoLtc}
        />
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    root.unmount();
  };
};
